
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[zone]/[slug]",
      function () {
        return require("private-next-pages/[zone]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[zone]/[slug]"])
      });
    }
  